import PrivacyPolicyPage from '../../src/client/pages/privacy-policy';

export default PrivacyPolicyPage;
